import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PageHeader from "components/common/PageHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Orders = () => {

    useEffect(() => {
        document.title = `Orders`
    }, [])

    return (<>
        <PageHeader
            title="Orders"
            description="Orders management"
            className="mb-3"
        />
    </>)
}

export default Orders